'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _resource = require('./resource.service');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resourceModule = _angular2.default.module('resource.service', []).service('Resource', _resource2.default).name;

exports.default = resourceModule;


// WEBPACK FOOTER //
// ./client/app/services/resourceService/resource.js